import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextArea from 'UIComponents/input/UITextArea';
import UITextInput from 'UIComponents/input/UITextInput';
import UITooltip from 'UIComponents/tooltip/UITooltip';

// @ts-expect-error untyped module
import { useHideDialog } from '../../../dialog/ducks';
// @ts-expect-error untyped module
import ActionSubmitButton from '../../shared/ActionSubmitButton';
// @ts-expect-error untyped module
import { ACTION_STATUSES } from '../../shared/actionStatuses';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddSectionHeaderToDashboardDialog = ({
  onSave,
  actionStatus = ACTION_STATUSES.NOT_STARTED,
  prevSectionHeading = '',
  prevSectionDescription = ''
}) => {
  const hideDialog = useHideDialog();
  const [sectionHeading, setSectionHeading] = useState(prevSectionHeading);
  const [sectionDescription, setSectionDecription] = useState(prevSectionDescription);
  const handleCloseDialog = () => hideDialog();
  const handleSectionHeadingChange = ({
    target: {
      value: newSectionHeading
    }
  }) => {
    setSectionHeading(newSectionHeading);
  };
  const handleSectionDescriptionChange = ({
    target: {
      value: newSectionDescription
    }
  }) => {
    setSectionDecription(newSectionDescription);
  };
  const isSaveDisabled = !sectionHeading;
  const isEditingExistingSectionHeader = !!prevSectionHeading;
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 800,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: handleCloseDialog
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isEditingExistingSectionHeader ? 'reporting-action-components.actions.addSectionHeader.dialog.title.edit' : 'reporting-action-components.actions.addSectionHeader.dialog.title.new'
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsxs(UIForm, {
        children: [/*#__PURE__*/_jsx(UIFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.addSectionHeader.dialog.sectionHeadingField"
          }),
          required: true,
          children: /*#__PURE__*/_jsx(UITextInput, {
            value: sectionHeading,
            onChange: handleSectionHeadingChange
          })
        }), /*#__PURE__*/_jsx(UIFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.addSectionHeader.dialog.sectionDescriptionField"
          }),
          children: /*#__PURE__*/_jsx(UITextArea, {
            value: sectionDescription,
            onChange: handleSectionDescriptionChange
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.addSectionHeader.dialog.save.disabledTooltip"
        }),
        disabled: !isSaveDisabled,
        children: /*#__PURE__*/_jsx(ActionSubmitButton, {
          use: "primary",
          actionStatus: actionStatus,
          onClick: () => onSave({
            sectionHeading,
            sectionDescription
          }),
          disabled: isSaveDisabled,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.addSectionHeader.dialog.save.button"
          })
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: handleCloseDialog,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.addSectionHeader.dialog.cancelButton"
        })
      })]
    })]
  });
};
export default AddSectionHeaderToDashboardDialog;